import { TheMask } from 'vue-the-mask'
import { countryMasks } from '@/helpers/helpers'

export default {
  name: 'CollaborationPhone',
  components: {
    TheMask,
  },
  props: {
    value: String,
    error: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: '',
    },
    countryCode: {
      type: String,
      default: 'cz',
    },
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  data() {
    return {
      inputValue: this.value || '',
    }
  },
  watch: {
    value(newVal) {
      this.inputValue = newVal
    },
    countryCode() {
      this.inputValue = ''
      this.$emit('input', '')
    },
  },
  computed: {
    phoneMask() {
      return this.countryCode && countryMasks[this.countryCode.toLowerCase()]
        ? countryMasks[this.countryCode.toLowerCase()]
        : '+### ### ### ###'
    },
    displayValue() {
      return this.inputValue
    },
    countryPrefix() {
      if (this.phoneMask) {
        const prefixMatch = this.phoneMask.match(/^([^#]+)/)
        return prefixMatch ? prefixMatch[0] : ''
      }
      return ''
    },
  },
  methods: {
    updateValue(value) {
      this.inputValue = value

      if (value) {
        const prefix = value.match(/^\+\d+/)

        const digits = value.replace(/[^0-9]/g, '')

        let cleanedValue = ''
        if (prefix && prefix[0]) {
          cleanedValue = prefix[0] + digits.substring(prefix[0].replace(/\+/g, '').length)
        } else if (this.countryPrefix) {
          const cleanPrefix = this.countryPrefix.replace(/[^\+\d]/g, '')
          cleanedValue = cleanPrefix + digits
        } else {
          cleanedValue = '+' + digits
        }

        this.$emit('input', cleanedValue)
      } else {
        this.$emit('input', '')
      }
    },
  },
}
